import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Quote from "./pages/Quote";
import Success from "./pages/Success";
import { Header } from "./containers/header/Header";
import { RecoilRoot } from "recoil";
import Footer from "./containers/footer/Footer";
import Impressum from "./containers/footer/Impressum";
import AGB from "./containers/footer/AGB";
import Datenschutz from "./containers/footer/Datenschutz";
import Fallback from "./pages/Fallback";
import Confirmation from "./pages/Confirmation";

function App() {
  const openModal = (id: string) => {
    const modal = document.getElementById(id) as HTMLDialogElement | null;
    if (modal) {
      modal.showModal();
    }
  };
  return (
    <div className="min-h-screen grid grid-rows-[1fr_auto]">
      <RecoilRoot>
        <Header />
        <Routes>
          <Route path="/" element={<Fallback />} />
          <Route path="/:customerId" element={<Quote />} />
          <Route path="/quote" element={<Success />} />
          <Route path="/quote/confirmation" element={<Confirmation />} />
        </Routes>
        <Footer
          openImpressum={() => {
            openModal("impressum-modal");
          }}
          openAGB={() => {
            openModal("agb-modal");
          }}
          openDatenschutz={() => {
            openModal("datenschutz-modal");
          }}
        />
        <Impressum />
        <AGB />
        <Datenschutz />
      </RecoilRoot>
    </div>
  );
}

export default App;
